// extracted by mini-css-extract-plugin
export default {"pageHolder":"Modal_pageHolder__kxK7e","modal":"Modal_modal__K+uUz"};